// sharedMenuConfig.js

export const menuByRole = {
  recruteur: [
    { name: 'dashboard', label: 'Dashboard' },
    { name: 'missions', label: 'Toutes les missions' },
    { name: 'missions', label: 'Mes missions' },
    { name: 'favoris', label: 'Mes favoris' },
    { name: 'candidatures', label: 'Mes candidatures' },
    { name: 'topmatches', label: 'Mes top matches' },
    { name: 'mesTalents', label: 'Mes talents' },
    { name: 'Profile', label: 'Profil' },
  ],
    agent:   [
    { name: 'dashboard', label: 'Dashboard' },
    { name: 'cvtheque', label: 'Cvthèque' },
  ],
  entreprise: [
    { name: 'dashboard', label: 'Dashboard' },
    { name: 'candidatures', label: 'Candidatures' },
    { name: 'missions', label: 'Missions' },
    { name: 'Profile', label: 'Profil' },
  ],
  admin: [
    { name: 'Dashboard', label: 'Dashboard' },
    { name: 'Entreprises', label: 'Entreprises' },
    { name: 'Recruteurs', label: 'Recruteurs' },
    { name: 'Candidatures', label: 'Candidatures' },
    { name: 'Cvtheque', label: 'Cvthèque' },
    { name: 'Missions', label: 'Missions' },
    { name: 'Administration', label: 'Administration' },
    { name: 'Roles', label: 'Rôles' },
  ],
    commercial: [
    { name: 'Dashboard', label: 'Dashboard' },
    { name: 'Entreprises', label: 'Entreprises' },
    { name: 'Recruteurs', label: 'Recruteurs' },
    { name: 'Candidatures', label: 'Candidatures' },
    { name: 'Cvtheque', label: 'Cvthèque' },
    { name: 'Missions', label: 'Missions' },
    { name: 'Administration', label: 'Administration' },
    { name: 'Roles', label: 'Rôles' },
  ],
    candidat:   [
    { name: 'dashboard', label: 'Dashboard' },
    { name: 'MesCvs', label: 'Mes Cvs' },
    { name: 'candidatures', label: 'Candidatures' },
  ],
};
